import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Select, { SingleValue } from 'react-select';
import { Dropdown, generatePositionTitle } from 'shared-utils';
import { useUserContext } from 'src/context/UserProvider';
import { useGetPositionsForRecruiterQuery } from 'src/hooks/position.hooks';
import { PositionStatus } from 'types';

const FresherCandidatesHeader = ({ onPositionChange }: { onPositionChange: () => void }) => {
	const { positionId } = useParams();
	const navigate = useNavigate();
	const { isAccountManagerLoggedIn } = useUserContext();
	const [positionsOptions, setPositionsOptions] = useState<Dropdown[]>([]);
	const {
		data: positionsData,
		isError: isPositionsDataError,
		isLoading: isPositionsDataLoading,
	} = useGetPositionsForRecruiterQuery(isAccountManagerLoggedIn, '', data => {
		// console.log('data:', data);
	});

	useEffect(() => {
		if (!isPositionsDataLoading) {
			setPositionsOptions(
				positionsData?.positions?.filter(e => e?.position?.positionStatus === PositionStatus.OPEN)?.map(e => ({
					value: e?.position?._id,
					label: generatePositionTitle(e?.position?.title),
				})) || [],
			);
		}
	}, [positionsData, isPositionsDataLoading]);

	return (
		<div className="flex gap-4 justify-start items-center py-2 pt-6 sm:pt-[10px] border-b border-[#EBEBF0] dark:border-[#555770] border-solid">
			<div className="text-xl font-semibold text-[#1C1C28] dark:text-white">Position</div>

			<div className="whiteBgSelect">
				<Select
					className="w-full md:w-[306px] !font-[400] !text-[16px]"
					menuPlacement={'auto'}
					classNamePrefix="my-select-plans"
					closeMenuOnSelect
					options={positionsOptions}
					isLoading={isPositionsDataLoading}
					value={positionsOptions?.find(o => o.value === positionId)}
					onChange={(
						val: SingleValue<{
							label: string;
							value: string;
						}>,
					) => {
						onPositionChange();
						if (val?.value) {
							navigate(`/view-candidates/position/${val.value}`);
						}
					}}
				/>
			</div>
		</div>
	);
};

export default FresherCandidatesHeader;
